import { render, staticRenderFns } from "./SocialMedias.vue?vue&type=template&id=69f204ed&"
import script from "./SocialMedias.vue?vue&type=script&lang=js&"
export * from "./SocialMedias.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports